
(function(){
  function blockClick(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if(!a) return;
    var href = a.getAttribute('href') || '';
    if(/\/checkout/i.test(href) || /\/products\//i.test(href) || /\/cart\/add/i.test(href)){
      e.preventDefault(); e.stopPropagation();
    }
  }
  document.addEventListener('click', blockClick, true);
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!f) return;
    var action = f.getAttribute('action') || '';
    if(/\/checkout/i.test(action) || /\/cart\/add/i.test(action)){
      e.preventDefault(); e.stopPropagation();
    }
  }, true);
  if(location.pathname.match(/\/checkout/i)){
    try{ location.href = '/'; }catch(e){}
  }
})();
